/** @jsx jsx */
/** @jsxFrag null */
import { AnyAttrs, Component, jsx } from 'panel';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { IronContextRegistry } from 'common/report/context-registry';
import css from './index.inline.styl';
export class EmptyData extends Component<EmptyObj, AnyAttrs, unknown, unknown, IronContextRegistry> {
  get config() {
    return {
      css,
      useShadowDom: true,
      contexts: ["i18n" as const],
      template: () => {
        const {
          t
        } = this.getContext("i18n");
        return <div sel='.empty-data' attrs={{
          elref: "emptyData"
        }}>
            <div sel='.empty-data-image-wrapper' />
            <div sel='.empty-data-text'>{t("insights.no-data.empty")}</div>
          </div>;
      }
    };
  }
}
export const EmptyDataEl = defineAndMakeJsxFactory("mp-empty-chart-data", EmptyData);
export const EmptyDataReact = panel2react("mp-empty-chart-data", EmptyData);